import getConfig from 'next/config'

export const { WALKMINING_WEB_API_HOST } = getConfig().publicRuntimeConfig
